import { KnownAuthError } from "@/api/client";
import { routes } from "@/constants/url";
import { ErrorBoundary } from "react-error-boundary";

export function AuthBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        if (KnownAuthError.is(error)) {
          const redirectUrl = error.redirectUrl;

          if (redirectUrl == null || Object.values(routes.AUTH).find((v) => redirectUrl.includes(v))) {
            window.location.href = routes.AUTH.signin;
            return null;
          }
          window.location.href = `${routes.AUTH.signin}?redirect_url=${redirectUrl}`;
          return null;
        }

        throw error;
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
